import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import styled from '@emotion/styled'
import { EnvironmentTitle, HeroPanel } from 'view/shared/heroPanel'
import { WindowActions } from 'epics/windowEpic'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 14px;
  }
`

export const InitiatedGridViewHeroPanel: React.FC = () => {
  const dispatch = useDispatch()

  const onTearout = useCallback(() => {
    dispatch(WindowActions.tearoutGrid('/quote/tearout/initiatedGridView'))
  }, [dispatch])

  return (
    <HeroPanel onTearout={onTearout}>
      <Wrapper>
        <EnvironmentTitle data-test-id={'InitiatedGridViewHeroPanel-EnvironmentTitle'}>Grid View</EnvironmentTitle>
      </Wrapper>
    </HeroPanel>
  )
}
